import { takeLatest, put, select, all, call } from 'redux-saga/effects';

import { INIT_APP } from 'src/store/view/constants';
import { takeOnce } from 'src/helpers/effects';

import { PAGINATION } from './constants';

import {
  hotelsVisibleLimitSelector,
  hotelsPageNumberSelector,
  hotelsHasPaginationSelector,
} from './selectors';
import { isExpandedMapSelector } from '../map/selectors';
import { getBrowser } from '../../selectors/browser';

import { toggleMap } from '../map/slice';
import { setVisibleHotels, updatePagination, setHasPagination } from './slice';

import { fetchData } from '../../sagas/search';
import { isSearchDone } from '../../searchStatus/selectors';

function* hotelsPagination() {
  const visibleCounts = yield select(hotelsVisibleLimitSelector);
  const hasPagination = yield select(hotelsHasPaginationSelector);
  const pageNumber: number = yield select(hotelsPageNumberSelector);

  const loadedHotels = (pageNumber || 1) * PAGINATION.PAGE_LIMIT;
  const loadMore = loadedHotels - visibleCounts <= PAGINATION.VISIBLE_LIMIT;
  const isDone = yield select(isSearchDone);

  if (hasPagination && loadMore && isDone) {
    yield put(updatePagination(pageNumber + 1));
  }
}

/**
 * Определяем, нужна ли пагинация для отелей
 * Пагинация активна, если карта не видна на странице
 */
function* detectPagination() {
  const hasPagination = yield select(hotelsHasPaginationSelector);

  // если определили, что пагинация не нужна, больше не меняем значение
  if (hasPagination === false) {
    return;
  }

  const isExpandedMap = yield select(isExpandedMapSelector);
  const browser = yield select(getBrowser);

  const withPagination = !isExpandedMap && browser.lessThan.extraLarge;

  yield put(setHasPagination(withPagination));
}

/**
 * Если раскрыли карту и была включена пагинация, то грузим все отели без пагинации, чтобы отобрахить на карте
 */
function* loadAllHotels() {
  yield call(detectPagination);

  const isExpandedMap = yield select(isExpandedMapSelector);
  const hasPagination = yield select(hotelsHasPaginationSelector);

  if (isExpandedMap && !hasPagination) {
    yield call(fetchData);
  }
}

export default function* hotelsSaga() {
  yield all([
    takeLatest([INIT_APP], detectPagination),
    takeLatest(setVisibleHotels.type, hotelsPagination),
    takeLatest(updatePagination.type, fetchData),
    takeOnce(toggleMap.type, loadAllHotels),
  ]);
}
